import React from "react";
import { useT } from "../../contexts/LanguageContext";
import {
  MagnifyingGlassIcon,
  FunnelIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";

const PRIORITIES = [
  { value: "", labelKey: "filter.priorityAll" },
  { value: "urgent", labelKey: "filter.priorityUrgent" },
  { value: "high", labelKey: "filter.priorityHigh" },
  { value: "normal", labelKey: "filter.priorityNormal" },
  { value: "low", labelKey: "filter.priorityLow" },
];

const ChatFilterBar = ({
  searchQuery,
  onSearchQueryChange,
  priority,
  onPriorityChange,
  hasUnread,
  onHasUnreadChange,
  onOpenSearch,
  showPriority = false,
}) => {
  const t = useT();

  return (
    <div className="border-b border-border-primary bg-bg-card">
      <div className="px-3 py-2 flex items-center gap-2">
        <MagnifyingGlassIcon className="w-4 h-4 text-text-secondary shrink-0" />
        <input
          value={searchQuery}
          onChange={(e) => onSearchQueryChange(e.target.value)}
          placeholder={t("filter.search")}
          className="flex-1 bg-transparent text-sm text-white outline-none placeholder-text-secondary"
        />
        {onOpenSearch && (
          <button
            onClick={onOpenSearch}
            title={t("filter.newChat")}
            className="p-1.5 rounded-lg bg-accent-grad text-white hover:opacity-90"
          >
            <PlusIcon className="w-4 h-4" />
          </button>
        )}
      </div>
      <div className="px-3 pb-2 flex items-center gap-2 flex-wrap">
        {showPriority && (
          <select
            value={priority || ""}
            onChange={(e) => onPriorityChange(e.target.value || null)}
            className="text-xs bg-bg-primary border border-gray-700 text-white rounded px-2 py-1"
          >
            {PRIORITIES.map((p) => (
              <option key={p.value} value={p.value}>
                {t("filter.priority")}: {t(p.labelKey)}
              </option>
            ))}
          </select>
        )}
        <button
          onClick={() => onHasUnreadChange(!hasUnread)}
          className={`text-xs px-2 py-1 rounded border transition-colors ${
            hasUnread
              ? "bg-green-500/20 border-green-500/50 text-green-400"
              : "bg-transparent border-gray-700 text-text-secondary hover:text-white"
          }`}
        >
          <FunnelIcon className="w-3.5 h-3.5 inline mr-1" />
          {t("filter.unread")}
        </button>
      </div>
    </div>
  );
};

export default ChatFilterBar;
